export class ServerErrorDTO {
    Data      : any;
    Status    : number;
    StatusText: string;
    Message   : string;
    Url       : string;
}